import { z } from 'zod';
import { JobRestorationChronicleType } from './jobChronicles.js';
export const JobFieldTechChronicleTypeSchema = z.enum([
    JobRestorationChronicleType.appointmentCompleted,
    JobRestorationChronicleType.appointmentScheduled,
    JobRestorationChronicleType.cancelled,
    JobRestorationChronicleType.completed,
    JobRestorationChronicleType.received,
    JobRestorationChronicleType.withdrawn,
    JobRestorationChronicleType.workDetailsReceived,
]);
export const JobFieldTechChronicleType = JobFieldTechChronicleTypeSchema.enum;
export const isJobFieldTechChronicle = (chronicle) => JobFieldTechChronicleTypeSchema.safeParse(chronicle.type).success;
/**
 * The JobFieldTechTimeline chronicle types before compilation
 */
export const JobFieldTechSourceTypeSchema = z.enum([
    ...JobFieldTechChronicleTypeSchema.options,
    JobRestorationChronicleType.reopened,
]);
export const JobFieldTechSourceType = JobFieldTechSourceTypeSchema.enum;
export const isJobFieldTechSourceChronicle = (chronicle) => JobFieldTechSourceTypeSchema.safeParse(chronicle.type).success;
